import { render, staticRenderFns } from "./recommendWord.vue?vue&type=template&id=2e945cf8&scoped=true&"
import script from "./recommendWord.vue?vue&type=script&lang=js&"
export * from "./recommendWord.vue?vue&type=script&lang=js&"
import style0 from "./recommendWord.vue?vue&type=style&index=0&id=2e945cf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e945cf8",
  null
  
)

export default component.exports